import { TDevice } from '@cian/utils';

export function getChartHeight(deviceType: TDevice) {
  switch (deviceType) {
    case 'desktop':
      return 202;
    case 'tablet':
    case 'phone':
      return 142;
  }
}
